import { render, staticRenderFns } from "./SellerRegistry.vue?vue&type=template&id=f4c89082&scoped=true&"
import script from "./SellerRegistry.vue?vue&type=script&lang=js&"
export * from "./SellerRegistry.vue?vue&type=script&lang=js&"
import style0 from "./SellerRegistry.vue?vue&type=style&index=0&id=f4c89082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c89082",
  null
  
)

export default component.exports